import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  tenants: { count: 0, rows: [] },
  tenant: {},
  loading: false,
  checkDelete: {},
  equipmentModels: [],
  equipmentModelLoading: false,
  equipmentModelsError: {},
  selectedEquipment: {},
  selectedEquipmentLoading: false,
  selectedEquipmentError: false,
  sitesForModals: { count: 0, rows: [] },
  loadingSites: false,
  loadingCreateDeleteApiKey: false,
  notificationWebhook: {
    actionsUrl: '',
    servicesUrl: '',
    showActionsNotifications: false,
    showServicesNotifications: false,
    active: false,
    apiKey: '',
  },
  loadingNotificationWebhook: false,
  registeredEquipments: 0,
  equipmentsLimitModalOpen: false,
  loadingGapUsersForOptions: false,
  gapUsersForOptions: { count: 0, rows: [] },
};

const requestTenantsStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchTenantsSuccess = (state, action) => {
  return updateObject(state, {
    tenants: action.tenants,
    loading: false
  });
};
const fetchTenantByIdSuccess = (state, action) => {
  return updateObject(state, {
    tenant: action.tenant,
    loading: false
  });
}

const requestTenantsFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteTenantsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteTenantsSuccess = (state, action) => {
  return updateObject(state, {
    checkDelete: action.checkDelete,
    loading: false
  });
}

const updateTenantsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postTenantsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const fetchEquipmentModelsStart = (state) => {
  return updateObject(state,{ equipmentModelLoading: true });
}

const fetchEquipmentModelsSuccess = (state, action) => {
  return updateObject(state, { equipmentModels: action.equipmentModels, equipmentModelLoading: false });
}

const fetchEquipmentModelsError = (state, action) => {
  return updateObject(state, { equipmentModelsError: action.error, equipmentModelLoading: false });
}

const fetchEquipmentByIdStart = (state) => {
  return updateObject(state,{ selectedEquipmentLoading: true });
}

const fetchEquipmentByIdSuccess = (state, action) => {
  return updateObject(state, { selectedEquipment: action.equipment, selectedEquipmentLoading: false });
}

const fetchEquipmentByIdError = (state, action) => {
  return updateObject(state, { selectedEquipmentError: action.error, selectedEquipmentLoading: false });
}

const fetchSitesForModalStart = (state) => {
  return updateObject(state, { loadingSites: true });
};

const fetchSitesForModalSuccess = (state, action) => {
  return updateObject(state, {
    sitesForModals: action.sites,
    loadingSites: false
  });
};

const fetchSitesForModalFail = (state) => {
  return updateObject(state, { loadingSites: false });
};

const requestApiKeyStart = (state) => {
  return updateObject(state, {loadingCreateDeleteApiKey: true })
}

const requestApiFinish = (state) => {
  return updateObject(state, {loadingCreateDeleteApiKey: false})
}

const updateNotificationWebhookStart = (state) => {
  return updateObject(state, { loadingNotificationWebhook: true })
}

const updateNotificationWebhookSuccessAndFail = (state) => {
  return updateObject(state, { loadingNotificationWebhook: false })
}

const getNotificationWebhookStart = (state) => {
  return updateObject(state, { loadingNotificationWebhook: true })
}

const getNotificationWebhookSuccess = (state, action) => {
  return updateObject(state, { loadingNotificationWebhook: false, notificationWebhook: action.notificationWebhook })
} 

const getNotificationWebhookFail = (state) => {
  return updateObject(state, { loadingNotificationWebhook: false })
}


const updateEquipmentsRegistrationLimitStart = (state) => {
  return updateObject(state, { loading: true })
}

const updateEquipmentsRegistrationLimitSuccess = (state) => {
  return updateObject(state, { loading: false })
}

const updateEquipmentsRegistrationLimitFail = (state) => {
  return updateObject(state, { loading: false })
}


const fetchEquipmentsCountStart = (state) => {
  return updateObject(state, { loading: true })
}

const fetchEquipmentsCountSuccess = (state, action) => {
  return updateObject(state, { loading: false, registeredEquipments: action.count })
}

const fetchEquipmentsCountFail = (state) => {
  return updateObject(state, { loading: false })
}

const toggleEquipmentsLimitModal = (state) => {
  return updateObject(state, { equipmentsLimitModalOpen: !state.equipmentsLimitModalOpen })
}

const fetchGapUsersForOptionsStart = (state) => {
  return updateObject(state, { loadingGapUsersForOptions: true });
};

const fetchGapUsersForOptionsFail = (state) => {
  return updateObject(state, { loadingGapUsersForOptions: false });
};

const fetchGapUsersForOptionsSuccess = (state, action) => {
  return updateObject(state, {
    gapUsersForOptions: action.users,
    loadingGapUsersForOptions: false
  });
};

const notifyAccountablesStart = (state) => {
  return updateObject(state, { loading: true });
};

const notifyAccountablesFail = (state) => {
  return updateObject(state, { loading: false });
};

const notifyAccountablesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_TENANTS_START: return requestTenantsStart(state, action);
    case actionTypes.FETCH_TENANTS_SUCCESS: return fetchTenantsSuccess(state, action);
    case actionTypes.FETCH_TENANTS_BY_ID_SUCCESS: return fetchTenantByIdSuccess(state, action);
    case actionTypes.REQUEST_TENANTS_FAIL: return requestTenantsFail(state, action);
    case actionTypes.DELETE_TENANTS_SUCCESS: return deleteTenantsSuccess(state, action);
    case actionTypes.CHECK_DELETE_TENANTS_SUCCESS: return checkDeleteTenantsSuccess(state, action);
    case actionTypes.UPDATE_TENANTS_SUCCESS: return updateTenantsSuccess(state, action);
    case actionTypes.POST_TENANTS_SUCCESS: return postTenantsSuccess(state, action);
    case actionTypes.TENANTS_FETCH_EQUIPMENT_MODELS_START: return fetchEquipmentModelsStart(state);
    case actionTypes.TENANTS_FETCH_EQUIPMENT_MODELS_SUCCESS: return fetchEquipmentModelsSuccess(state, action);
    case actionTypes.TENANTS_FETCH_EQUIPMENT_MODELS_ERROR: return fetchEquipmentModelsError(state, action);
    case actionTypes.TENANTS_FETCH_EQUIPMENT_BY_ID_START: return fetchEquipmentByIdStart(state);
    case actionTypes.TENANTS_FETCH_EQUIPMENT_BY_ID_SUCCESS: return fetchEquipmentByIdSuccess(state, action);
    case actionTypes.TENANTS_FETCH_EQUIPMENT_BY_ID_ERROR: return fetchEquipmentByIdError(state, action);
    case actionTypes.TENANTS_FETCH_SITES_FOR_MODALS_START: return fetchSitesForModalStart(state);
    case actionTypes.TENANTS_FETCH_SITES_FOR_MODALS_SUCCESS: return fetchSitesForModalSuccess(state, action);
    case actionTypes.TENANTS_FETCH_SITES_FOR_MODALS_FAIL: return fetchSitesForModalFail(state);
    case actionTypes.TENANT_CREATE_API_KEY_START : return requestApiKeyStart(state);
    case actionTypes.TENANT_CREATE_API_KEY_SUCCESS: return requestApiFinish(state);
    case actionTypes.TENANT_CREATE_API_KEY_FAIL: return requestApiFinish(state);
    case actionTypes.TENANT_DELETE_API_KEY_START : return requestApiKeyStart(state);
    case actionTypes.TENANT_DELETE_API_KEY_SUCCESS: return requestApiFinish(state);
    case actionTypes.TENANT_DELETE_API_KEY_FAIL: return requestApiFinish(state);
    case actionTypes.TENANT_UPDATE_WEBHOOK_START: return updateNotificationWebhookStart(state);
    case actionTypes.TENANT_UPDATE_WEBHOOK_SUCCESS: return updateNotificationWebhookSuccessAndFail(state);
    case actionTypes.TENANT_UPDATE_WEBHOOK_FAIL: return updateNotificationWebhookSuccessAndFail(state);
    case actionTypes.TENANT_GET_WEBHOOK_START: return getNotificationWebhookStart(state);
    case actionTypes.TENANT_GET_WEBHOOK_SUCCESS: return getNotificationWebhookSuccess(state, action);
    case actionTypes.TENANT_GET_WEBHOOK_FAIL: return getNotificationWebhookFail(state);
    case actionTypes.TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_START: return updateEquipmentsRegistrationLimitStart(state);
    case actionTypes.TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_SUCCESS: return updateEquipmentsRegistrationLimitSuccess(state);
    case actionTypes.TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_FAIL: return updateEquipmentsRegistrationLimitFail(state);
    case actionTypes.TENANT_FETCH_EQUIPMENTS_COUNT_START: return fetchEquipmentsCountStart(state);
    case actionTypes.TENANT_FETCH_EQUIPMENTS_COUNT_SUCCESS: return fetchEquipmentsCountSuccess(state, action);
    case actionTypes.TENANT_FETCH_EQUIPMENTS_COUNT_FAIL: return fetchEquipmentsCountFail(state);
    case actionTypes.TOGGLE_EQUIPMENTS_LIMIT_MODAL: return toggleEquipmentsLimitModal(state);
    case actionTypes.TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_START: return fetchGapUsersForOptionsStart(state);
    case actionTypes.TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_SUCCESS: return fetchGapUsersForOptionsSuccess(state, action);
    case actionTypes.TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_FAIL: return fetchGapUsersForOptionsFail(state);
    case actionTypes.TENANT_NOTIFY_ACCOUNTABLES_START: return notifyAccountablesStart(state);
    case actionTypes.TENANT_NOTIFY_ACCOUNTABLES_SUCCESS: return notifyAccountablesSuccess(state, action);
    case actionTypes.TENANT_NOTIFY_ACCOUNTABLES_FAIL: return notifyAccountablesFail(state);
    default: return state;
  }
};

export default reducer;